import { createGlobalStyle } from "styled-components";
import {
  backDropFilter,
  blueDark,
  cyanLight,
  greenYellowColor,
  mainColor,
  pinkLight,
  whiteAlpha25,
  whiteAlpha40,
} from "./style-guide";

export const customMediaQuery = (maxWidth: number) =>
  `@media (max-width: ${maxWidth}px)`;

export const media = {
  custom: customMediaQuery,
  desktop: customMediaQuery(1100),
  tablet: customMediaQuery(870),
  phone: customMediaQuery(545),
};

const GlobalStyle = createGlobalStyle<{ open: boolean; navOpen: boolean }>`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    outline: none;

    &::after,&::before {
      box-sizing: border-box;
    }
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background-color: white;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${mainColor};
  }

  body {
    min-height: 100vh;
    background-image: linear-gradient(to bottom right, ${pinkLight}, ${cyanLight});
    background-attachment: fixed;
    font-size: 16px;
    font-family: 'Poppins', sans-serif;
    font-weight:300;
    color: ${blueDark};
    line-height: 1.5;
    overflow-x: hidden;
    -webkit-tap-highlight-color: transparent;
    padding: 5vh 15px;
    ${({ open, navOpen }) => (open || navOpen) && "overflow-y: hidden;"}

    &::before {
      content:"";
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: ${greenYellowColor};
      z-index: -1;
      opacity: 0.12;
    }
  }

  h1, h2 {
    font-weight: 600;
  }
  h3, h4, h5, h6 {
    font-weight: 500;
  }

  section {
    background-color: ${whiteAlpha25};
    border: 1px solid ${whiteAlpha40};
    min-height: 90vh;
    border-radius: 30px;
    backdrop-filter: ${backDropFilter};
    ${({ navOpen }) =>
      navOpen
        ? `animation: fadeOut 0.3s ease-in-out forwards;`
        : `animation: fadeIn 0.3s ease-in-out forwards;`}


  }

  @keyframes fadeIn {
    0%{
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    0%{
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }


  img {
    max-width: 100%;
    vertical-align: middle;
  }

  ul {
    list-style: none;
  }
`;

export default GlobalStyle;
